export default __webpack_public_path__ + "static/media/pic7.d3af128f.jpg";